
import { htmlLang } from '@/utils/locales'

export default {
  name: 'Login',
  head() {
    return {
      htmlAttrs: { lang: htmlLang(this.$i18n.localeProperties) },
    }
  },
  mounted() {
    if (
      this.$route.query.token &&
      this.$route.path != '/nouveau-mot-de-passe'
    ) {
      this.$userService
        .verifyEmail({ token: this.$route.query.token })
        .then(data => {
          this.$swalCustomSuccess(
            this.$t('layouts.login.emailVerifiedTitle'),
            this.$t('layouts.login.emailVerifiedMessage')
          )
          this.$router.push(
            this.localePath({
              name: 'connexion',
              query: {
                token: undefined,
              },
            })
          )
        })
        .catch(error => {
          const tokenError = error.response?.data?.errors?.token?.[0]

          if (tokenError) {
            this.$swalInfoCustomMessage(
              this.$t('layouts.login.emailVerificationFailedTitle'),
              tokenError.startsWith('validation.')
                ? this.$t('layouts.login.emailVerificationFailedMessage')
                : tokenError
            )
          } else {
            this.$swalErrorMessage(error)
          }

          this.$router.push(
            this.localePath({
              name: 'connexion',
              query: {
                token: undefined,
              },
            })
          )
        })
    }
  },
}
